<template>
  <div v-if="totalItems > 10">
    <div class="ls-pagination-filter">
      <div class="ls-filter-view">
        {{ $t('application.pagination.display') }}
        <div class="ls-custom-select">
          <select v-on:change="changePerPage()" v-model="perPage" class="ls-select">
            <option v-for="selectValue in selectValues" :value="selectValue">
              {{ selectValue }}
            </option>
          </select>
        </div>
        {{ $t('application.pagination.items_per_page') }}
      </div>
      <div class="total-items">
        <div>{{ $root.plural(totalItems, 'application.pagination.found_items') }}</div>
      </div>
      <div class="pages" v-if="totalItems > 0">
        <paginate :page-count="totalPages" :forcePage="currentPage - 1" :initial-page="currentPage - 1" :page-range="3" :margin-pages="1" :click-handler="callBack" :prev-text="$t('application.pagination.previous')" :next-text="$t('application.pagination.next')" :container-class="'pagination'" :page-class="'page-item'"></paginate>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from './vuex/mutations-types'
import { addPaginationFlash, clearPaginationFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'

export default {
  props: {
    'updater': Function,
    'initialPerPage': {
      type: Number,
      default: 10
    },
    'perPageValues': Array
  },
  data () {
    return {
      perPage: this.initialPerPage,
      selectValues: this.perPageValues || [10, 20, 30, 50, 100],
      watch: true
    }
  },
  mounted () {
    this.$store.commit(types.setPagination, {per_page: this.perPage})
    this.$watch('types.pageData', function (newVal, oldVal) {
      if (newVal.length > 0) {
        this.$store.commit(clearPaginationFlash)
      } else {
        this.$store.commit(addPaginationFlash, { message: this.$t('application.pagination.not_found_items'), type: 'ls-alert-warning' })
      }
    })
    this.$watch('pagination.per_page', function (val) {
      this.watch = false
      this.perPage = val
      this.watch = true
    })
  },
  computed: {
    ...mapGetters(['pagination']),
    totalPages () {
      return Math.ceil(this.totalItems / this.itemsPerPage)
    },
    totalItems () {
      return this.pagination['total_count']
    },
    itemsPerPage () {
      return this.pagination['per_page']
    },
    currentPage () {
      return this.pagination['current_page']
    }
  },
  methods: {
    callBack (pageNum) {
      this.pagination.current_page = pageNum
      this.updateList()
    },
    setPage (pageNumber) {
      this.pagination.current_page = pageNumber
    },
    setItemsPerPage (quantity) {
      this.pagination.per_page = quantity
    },
    updateList () {
      window.scrollTo(0, 0)
      this.updater()
    },
    changePerPage () {
      this.setItemsPerPage(this.perPage)
      this.setPage(1)
      this.updateList()
    }
  },
  beforeDestroy () {
    this.$store.commit(types.setPageData, {})
    this.$store.commit(types.setPagination, {})
  }
}
</script>
<style lang="scss">
  .ls-pagination-filter {
    display: flex!important;
    justify-content: space-between;
    @media screen and (max-width: 1160px) {
      display: inline-block!important;
      text-align: center!important;
      .ls-pagination {
        float: none;
      }
    }
    .total-items {
      div {
        margin: 10px 0px;
      }
    }
  }
  .pages {
    display: inline-block;
    .pagination {
      margin: 0;
      list-style: none;
      li {
        &:first-child {
          a {
            &:first-child {
              &:before {
                content: "«";
                margin: 0 5px 0 0px;
              }
            }
          }
        }
        &:last-child {
          a {
            &:last-child {
              &:after {
                content: "»";
                margin: 0 0 0 5px;
              }
            }
          }
        }
        &.disabled {
          a {
            background: rgba(136, 136, 136, 0.21);
            pointer-events: none;
          }
        }
      }
      a {
        &:hover {
          background-color: #ddd;
        }
      }
      .page-item {
        &.active {
          a {
            background: #169944;
            border-color: #ddd;
            color: #fff;
            &:hover, &:focus {
              background: #0f6c30;
              border-color: #0f6c30;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Pagination.vue?383ed4de